import * as Bixby from '$/core';

export class LoggerService {
  /** Enable tracing output in the console, for localhost only. */
  public static log(msg: string, obj?: unknown) {
    if (Bixby.Configuration?.shouldLogLocal ?? false) {
      // eslint-disable-next-line no-console
      console.log(
        msg,
        obj
      );
    }
  }
}
